export const CLUBS = [
  { value: 'driver', label: 'Driver' },
  { value: '3-wood', label: '3 Wood' },
  { value: '5-wood', label: '5 Wood' },
  { value: 'hybrid', label: 'Hybrid' },
  { value: '3-iron', label: '3 Iron' },
  { value: '4-iron', label: '4 Iron' },
  { value: '5-iron', label: '5 Iron' },
  { value: '6-iron', label: '6 Iron' },
  { value: '7-iron', label: '7 Iron' },
  { value: '8-iron', label: '8 Iron' },
  { value: '9-iron', label: '9 Iron' },
  { value: 'pw', label: 'Pitching Wedge' },
  { value: 'gw', label: 'Gap Wedge' },
  { value: 'sw', label: 'Sand Wedge' },
  { value: 'lw', label: 'Lob Wedge' },
];

export const getClubLabel = (value) => {
  const club = CLUBS.find(c => c.value === value);
  return club?.label || value;
};
